var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');
var initialize = require('./tripletrax.initialize.js');
var access = require('./tripletrax.access.js');

function selectNestableElement(element, doInitializeElements) {

    return $.Deferred(function (defer) {
        var dd_id = element.parents('.dd-dragel').data('tt-dd-id');
        if (utils.isUndefined(dd_id)) {
            dd_id = element.parents('.dd')[0].id;
        }

        var dd = $('#' + dd_id);

        dd.find('.tt-button-nestable').addClass('hide');
        dd.find('.dd-handle').removeClass('dd-content-active');
        element.parents('.dd-list').find('.tt-button-nestable').addClass('hide');
        element.parents('.dd-list').find('.dd-handle').removeClass('dd-content-active');

        var id = element.parents('.dd-item')[0].getAttribute('data-id');
        element.parents('.tt-content').find('.tt-selected-id').val(id);

        var viewId = element.parents('.dd-item')[0].getAttribute('data-view-id');
        element.parents('.tt-content').find('.tt-selected-view-id').val(viewId);

        element.find('.tt-button-nestable').removeClass('hide');
        element.addClass('dd-content-active');

        // Preview Button nur für Views aktiv setzen
        var viewType = element.parents('.dd-item')[0].getAttribute('data-type');
        if (viewType !== 'global' && viewType !== 'basic') {
            dd.parents('.tt-content').find('.tt-preview').removeClass('disabled');
        } else {
            dd.parents('.tt-content').find('.tt-preview').addClass('disabled');
        }

        if (dd_id === "dd_course_views") {

            element.parents('.tt-content-datatable').find('.tt-delete').removeClass('disabled');

            if (element.parents('.dd-item')[0].getAttribute('data-category') !== null && element.parents('.dd-item')[0].getAttribute('data-category') !== '') {
                element.parents('.tt-content-datatable').find('.tt-update').removeClass('disabled');
                element.parents('.tt-content-datatable').find('.tt-set-start').removeClass('disabled');
            } else {
                element.parents('.tt-content-datatable').find('.tt-update').addClass('disabled');
                element.parents('.tt-content-datatable').find('.tt-set-start').addClass('disabled');
            }
            defer.resolve();

        } else {

            // Recht für Speichern-Button setzen
            $('.tt-save-data-views-group').find('button').removeAttr('disabled');
            $('.tt-save-data-views-group').find('button').removeClass('disabled');
            $('.tt-save-data-views-group').find('button').removeClass('no-rights');
            $('.tt-save-data-views-group').find('button').removeClass('hide');

            if (parseInt(id) > 0) {
                $('.tt-save-data-views-group').find('button').removeClass('tt-right-button-write').addClass('tt-right-button-update');
                access.setControlsDependingOnRights($('.tt-save-data-views-group'), true, false);
            } else {
                $('.tt-save-data-views-group').find('button').removeClass('tt-right-button-update').addClass('tt-right-button-write');
                access.setControlsDependingOnRights($('.tt-save-data-views-group'), true, false);
            }

            if (parseInt(id) > 0) {
                var newUrl = dd.data('list-url') + "/" + id;

                ajax.ajaxCallDeferred(newUrl, 'GET', null, false).done(function(data) {

                    if (ajax.ajaxSucceeded(data)) {
                        utils.setHtmlData($("#content-detail"), data[0], doInitializeElements);
                        utils.setHtmlData($("#content-detail-modal"), data[1], doInitializeElements);

                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                });
            } else {
                defer.resolve();
            }
        }
    }).promise();
}

function unsetNestableParent(item) {
    if (item.children('ol').length === 0 || item.children('ol').children().length === 0) {
        item.children().remove('ol');
        item.removeClass('dd-collapsed');
        item.children('[data-action]').remove();
    }
}

function setNestableParent(item) {
    if (item.children('ol').length > 0) {

        item.prepend($('<button data-action="expand" type="button">Expand</button>'));
        item.prepend($('<button data-action="collapse" type="button">Collapse</button>'));
    }
    item.children('[data-action="expand"]').hide();
}

function clickElement(el, doInitializeElements) {

    return $.Deferred(function (defer) {
        utils.updateGlobals('programmaticClick', true);
        if ($(el).is('.dd-handle')) {
            selectNestableElement($(el), doInitializeElements).done(function () {
                utils.updateGlobals('programmaticClick', false);
                defer.resolve();
            });
        } else if ($(el).parents('.dd-handle:not(.dd-handle-completeness,.dd-completeness-parent)').length) {
            selectNestableElement($(el).parents('.dd-handle'), doInitializeElements).done(function () {
                if ($(el).hasClass('dd-nodrag')) {
                    $(el).click();
                } else if ($(el).parents('a').hasClass('dd-nodrag')) {
                    $(el).parents('a').click();
                }
                utils.updateGlobals('programmaticClick', false);
                defer.resolve();
            });
        } else {
            el.click();
            utils.updateGlobals('programmaticClick', false);
            defer.resolve();
        }

    }).promise();
}

function showDataViewNestableItemClicked(data) {

    // Element welches vor saveChanges angeklickt wurde muss wieder neu gesucht werden, da der ganze Inhalt ersetzt wird.
    var position = 0;
    var clickSaveButton = false;
    var clickDeleteButton = false;
    if (utils.GLOBALS.elementToClickAfterSave != null && ($(utils.GLOBALS.elementToClickAfterSave).is('.dd-handle') || $(utils.GLOBALS.elementToClickAfterSave).parents('.dd-handle').length)) {
        position = parseInt($(utils.GLOBALS.elementToClickAfterSave).parents('.dd-item').data().position);

        if ($(utils.GLOBALS.elementToClickAfterSave).is('.tt-add-nestable') || $(utils.GLOBALS.elementToClickAfterSave).parents('.tt-add-nestable').length) {
            clickSaveButton = true;
        } else if ($(utils.GLOBALS.elementToClickAfterSave).is('.tt-delete-nestable') || $(utils.GLOBALS.elementToClickAfterSave).parents('.tt-delete-nestable').length) {
            clickDeleteButton = true;
        }
    }
    var collapsedItems = $('#dd_data_views').find('.dd-collapsed');
    var scrollPosition = $('#dd_data_views').parents('fieldset').scrollTop();

    utils.setHtmlData($("#content"), data, true);
    $('#dd_data_views').nestable('expandAll');

    if (position > 0) {
        var nestableElement = null;
        if (clickSaveButton) {
            nestableElement = $($("#content").find("[data-position='" + position + "']").find('.dd-handle').find('.tt-add-nestable')[0]);
        } else if (clickDeleteButton) {
            nestableElement = $($("#content").find("[data-position='" + position + "']").find('.dd-handle').find('.tt-delete-nestable')[0]);
        } else {
            nestableElement = $($("#content").find("[data-position='" + position + "']").find('.dd-handle')[0]);
        }

        clickElement(nestableElement, true).done(function () {
            utils.updateGlobals('elementToClickAfterSave', null);

            if (utils.GLOBALS.secondElementToClickAfterSave != null && ($(utils.GLOBALS.secondElementToClickAfterSave).is('.tt-preview') || $(utils.GLOBALS.secondElementToClickAfterSave).parents('a,button').hasClass('tt-preview'))) {
                clickElement($($("#content").find('.tt-preview')[0]), true);
                utils.updateGlobals('secondElementToClickAfterSave', null);
            }
        });
    }
    for (var i = collapsedItems.length - 1; i >= 0; i--) {
        $('#dd_data_views').nestable(['collapseItem', $('#dd_data_views').find('[data-id="' + $(collapsedItems[i]).data().id + '"]')]);
    }
    $('#dd_data_views').parents('fieldset').scrollTop(scrollPosition);

	$('.tt-please-wait-save-data-views').addClass('hide');
}

module.exports.selectNestableElement = selectNestableElement;
module.exports.unsetNestableParent = unsetNestableParent;
module.exports.setNestableParent = setNestableParent;
module.exports.clickElement = clickElement;
module.exports.showDataViewNestableItemClicked = showDataViewNestableItemClicked;
